import { create } from 'zustand';

import { ProdtVoucherView } from '@mopla/data-models';

export interface IValidVoucherData extends ProdtVoucherView {
	code: string;
}

interface IVoucherStore {
	// State
	validVoucher: IValidVoucherData | null;
	voucherCode: string | null; // Actual code entered by user (kept for backward compatibility)
	validationError: string | null;

	// Actions
	setValidVoucher: (voucher: IValidVoucherData | null) => void;
	setVoucherCode: (code: string | null) => void;
	setValidationError: (error: string | null) => void;
	reset: () => void;
}

const initialState = {
	validVoucher: null,
	voucherCode: null,
	validationError: null,
};

export const useVoucherStore = create<IVoucherStore>((set) => ({
	...initialState,

	setValidVoucher: (voucher) => set({ validVoucher: voucher }),

	setVoucherCode: (code) => set({ voucherCode: code }),

	setValidationError: (error) => set({ validationError: error }),

	reset: () => set(initialState),
}));
